export const BankMap: Record<string, string> = {
    BANK_OF_KOREA: "한국은행",
    KDB: "산업은행",
    IBK: "기업은행",
    KOOKMIN: "국민은행",
    SUHYUP: "수협은행",
    KEXIM: "수출입은행",
    NONGHYUP: "NH농협은행",
    LOCAL_NONGHYUP: "지역농축협",
    WOORI: "우리은행",
    STANDARD_CHARTERED: "SC제일은행",
    CITI: "한국씨티은행",
    DAEGU: "아이엠뱅크",
    BUSAN: "부산은행",
    KWANGJU: "광주은행",
    JEJU: "제주은행",
    JEONBUK: "전북은행",
    KYONGNAM: "경남은행",
    KFCC: "새마을금고",
    SHINHYUP: "신협",
    SAVINGS_BANK: "저축은행",
    MORGAN_STANLEY: "모간스탠리은행",
    HSBC: "HSBC은행",
    DEUTSCHE: "도이치은행",
    JPMC: "제이피모간체이스은행",
    MIZUHO: "미즈호은행",
    MUFG: "엠유에프지은행",
    BANK_OF_AMERICA: "BOA은행",
    BNP_PARIBAS: "비엔피파리바은행",
    ICBC: "중국공상은행",
    BANK_OF_CHINA: "중국은행",
    NFCF: "산림조합중앙회",
    UOB: "대화은행",
    BOCOM: "교통은행",
    CCB: "중국건설은행",
    POST: "우체국",
    KODIT: "신용보증기금",
    KIBO: "기술보증기금",
    HANA: "하나은행",
    SHINHAN: "신한은행",
    K_BANK: "케이뱅크",
    KAKAO: "카카오뱅크",
    TOSS: "토스뱅크",
    MISC_FOREIGN: "기타 외국계은행(중국 농업은행 등)",
    SGI: "서울보증보험",
    KCIS: "한국신용정보원",
    YUANTA_SECURITIES: "유안타증권",
    KB_SECURITIES: "KB증권",
    SANGSANGIN_SECURITIES: "상상인증권",
    HANYANG_SECURITIES: "한양증권",
    LEADING_SECURITIES: "리딩투자증권",
    BNK_SECURITIES: "BNK투자증권",
    IBK_SECURITIES: "IBK투자증권",
    DAOL_SECURITIES: "다올투자증권",
    MIRAE_ASSET_SECURITIES: "미래에셋증권",
    SAMSUNG_SECURITIES: "삼성증권",
    KOREA_SECURITIES: "한국투자증권",
    NH_SECURITIES: "NH투자증권",
    KYOBO_SECURITIES: "교보증권",
    HI_SECURITIES: "하이투자증권",
    HYUNDAI_MOTOR_SECURITIES: "현대차증권",
    KIWOOM_SECURITIES: "키움증권",
    EBEST_SECURITIES: "LS증권",
    SK_SECURITIES: "SK증권",
    DAISHIN_SECURITIES: "대신증권",
    HANHWA_SECURITIES: "한화투자증권",
    HANA_SECURITIES: "하나증권",
    TOSS_SECURITIES: "토스증권",
    SHINHAN_SECURITIES: "신한투자증권",
    DB_SECURITIES: "DB금융투자",
    EUGENE_SECURITIES: "유진투자증권",
    MERITZ_SECURITIES: "메리츠증권",
    KAKAO_PAY_SECURITIES: "카카오페이증권",
    BOOKOOK_SECURITIES: "부국증권",
    SHINYOUNG_SECURITIES: "신영증권",
    CAPE_SECURITIES: "케이프투자증권",
    KOREA_SECURITIES_FINANCE: "한국증권금융",
    KOREA_FOSS_SECURITIES: "한국포스증권",
    WOORI_INVESTMENT_BANK: "우리종합금융",
};
